module.exports = __webpack_public_path__ + "img/event_bg_mask.da1a5865.svg";